// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j2hE","newExpiryDate":"styles_newExpiryDate__3elTl","footer":"styles_footer__Yns07"};